import axios from 'axios';
import { API_BASE } from './config';
import { InviteRecord } from '../types/models';

type InviteCreateResponse = InviteRecord & { invite_url: string };

export async function getInvites(): Promise<InviteRecord[]> {
  const response = await axios.get<InviteRecord[]>(`${API_BASE}/invites`);
  return response.data;
}

export async function createInvite(email: string): Promise<InviteCreateResponse> {
  const response = await axios.post<InviteCreateResponse>(`${API_BASE}/invites`, {
    invite: { email },
  });
  return response.data;
}

export async function revokeInvite(id: number): Promise<InviteRecord> {
  const response = await axios.post<InviteRecord>(`${API_BASE}/invites/${id}/revoke`);
  return response.data;
}

export type AcceptInviteResponse = { token: string; user: { id: number; email: string; admin: boolean } };

export async function acceptInvite(
  token: string,
  password: string,
  passwordConfirmation: string
): Promise<AcceptInviteResponse> {
  const response = await axios.post<AcceptInviteResponse>(`${API_BASE}/invites/accept`, {
    token,
    password,
    password_confirmation: passwordConfirmation,
  });
  return response.data;
}
